document.addEventListener("DOMContentLoaded", function () {
  const b2bBtn = document.getElementById("b2bBtn");
  const b2cBtn = document.getElementById("b2cBtn");
  const headerElement = document.querySelector('[data-desktop-header]'); // Target the main header
  
  // Exit if necessary elements aren't found
  if (!b2bBtn || !b2cBtn || !headerElement) return;

  const STICKY_CLASS = 'is-sticky'; // Replace with the actual sticky class
  const HOMEPAGE_URL = "/"; // Change if your homepage URL is different

  // Function to gather all toggle items across the entire document
  function getToggleItems() {
    return {
      b2cItems: document.querySelectorAll(".b2c-toggle-item"),
      b2bItems: document.querySelectorAll(".b2b-toggle-item")
    };
  }

  // Core function to update visibility and save state
  function updateView(isB2C) {
    const { b2cItems, b2bItems } = getToggleItems();
    
    // Toggle visibility of content
    b2cItems.forEach(el => el.classList.toggle("visible", isB2C));
    b2bItems.forEach(el => el.classList.toggle("visible", !isB2C));

    // Toggle active button styling
    b2cBtn.classList.toggle("active", isB2C);
    b2bBtn.classList.toggle("active", !isB2C);

    // Save the current state
    localStorage.setItem("toggleState", isB2C);
  }

  // --- Initial Load ---
  const savedState = localStorage.getItem("toggleState") === "true";
  updateView(savedState);

  // --- Event Listeners ---
  function handleClick(isB2C) {
    updateView(isB2C);

    // Redirect only if not on homepage
    if (window.location.pathname !== HOMEPAGE_URL) {
      window.location.href = HOMEPAGE_URL;
    }
  }

  b2bBtn.addEventListener("click", function () {
    handleClick(false);
  });

  b2cBtn.addEventListener("click", function () {
    handleClick(true);
  });

  // --- Sticky Header Observer ---
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (
        mutation.type === 'attributes' && 
        mutation.attributeName === 'class' && 
        headerElement.classList.contains(STICKY_CLASS)
      ) {
        // When the sticky class is added, re-apply the current view state
        const currentState = localStorage.getItem("toggleState") === "true";
        updateView(currentState);
      }
    });
  });

  observer.observe(headerElement, { attributes: true });
});
